<template>
  <div class="collapse">
    <div class="collapse__header" @click="isOpened = !isOpened">
      <h3 class="collapse__header-title">{{ title }}</h3>
      <span class="collapse__header-plus">+</span>
    </div>
    <div class="collapse__body" :class="{ 'is-opened': isOpened }">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AppCollapse',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  setup() {
    const isOpened = ref(false)

    return { isOpened }
  }
})
</script>

<style lang="scss" scoped src="./Index.scss" />
